import { Backdrop } from "@material-ui/core";
import OrderProcessingView, {
  OrderProcessStatus
} from "@saleor/apps/components/OrderProcessing";
import { showNotifyMessage } from "@saleor/changeOrder/utils";
import { changeOrderPath } from "@saleor/changeOrderExport/urls";
import { ViewEditMode } from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import DialogConfirmError from "@saleor/components/DialogConfirmError";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import Skeleton from "@saleor/components/Skeleton";
import SnackbarAlert from "@saleor/components/SnackbarAlert";
import { Tab, TabContainer } from "@saleor/components/Tab";
import TimeOutPage from "@saleor/components/TimeOutPage";
import { defaultListSettings } from "@saleor/config";
import { orderCartlUrl } from "@saleor/createOrder/urls";
import AgencyTab from "@saleor/createOrderExport/components/AgencyTab";
import DialogConfirmOrder from "@saleor/createOrderExport/components/DialogConfirmOrder";
import DialogError from "@saleor/createOrderExport/components/DialogError";
import DrawAddProduct from "@saleor/createOrderExport/components/DrawAddProduct";
import MaterialItemTab from "@saleor/createOrderExport/components/MaterialItemTab";
import OrderHeaderTab from "@saleor/createOrderExport/components/OrderHeaderTab";
import { DrawAddExportType } from "@saleor/createOrderExport/const";
import { ExportOrderQueryParams } from "@saleor/createOrderExport/urls";
import {
  checkTotalQuantity,
  createPackingList
} from "@saleor/createOrderExport/views/CreateOrderView/utils";
import {
  ExportOrderLineAddProductInput,
  ExportOrderUpdateInput,
  ScgpExportErrorCode,
  ScgpExportOrderStatus,
  useAddProductsToExportOrderMutation,
  useExportOrderWithAllItemsQuery,
  useTotalCountExportCartQuery,
  useUpdateAllExportOrderLineMutation,
  useUpdateExportOrderMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginationLocal from "@saleor/hooks/usePaginationLocal";
import { makeStyles } from "@saleor/macaw-ui";
import { ListViews } from "@saleor/types";
import { convertValueObjectToNull } from "@saleor/utils/data/convertValueObjectToNull";
import { mapEdgesToItems } from "@saleor/utils/maps";
import {
  calculateNewPackage,
  calculateNewPalletNo,
  calculateNewTotalWeight
} from "@saleor/utils/number";
import { getSortParams, getSortUrlVariables } from "@saleor/utils/sort";
import lodash_orderBy from "lodash/orderBy";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import useRouter from "use-react-router";

import CreateOrderFooter from "./components/CreateOrderFooter";

interface CreateOrderViewProps {
  id: string;
  params: ExportOrderQueryParams;
}

export enum CreateOrderPageTab {
  agency = "agency",
  orderHeader = "orderHeader",
  materialItem = "materialItem"
}

export interface DataCartDetailProps {
  piNo: string;
  soldTo: string;
}

const CategoriesTab = Tab(CreateOrderPageTab.agency);
const CollectionsTab = Tab(CreateOrderPageTab.orderHeader);
const ProductsTab = Tab(CreateOrderPageTab.materialItem);

const useStyles = makeStyles(
  theme => ({
    tab: {
      padding: "10px 0",
      textAlign: "center"
    },
    tabBox: {
      [theme.breakpoints.down("sm")]: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        "& .MuiTypography-subtitle1": {
          fontSize: "1.5rem"
        },
        "& > *": {
          minWidth: "unset"
        }
      },
      "&>span:first-child": {
        borderRadius: "12px 0 0 0"
      },
      "&>span:last-child": {
        borderRadius: "0 12px 0 0"
      }
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    boxContainer: {
      paddingBottom: "20rem"
    },
    backDrop: {
      zIndex: 1399
    },

    inlineBlock: {
      display: "inline-block",
      color: theme.palette.grey[900]
    }
  }),
  {
    name: "CreateOrderView"
  }
);

export enum TypeOfAddProd {
  Successfully = "success",
  UnSuccessfully = "error"
}
export enum ModeUpdate {
  DraftSuccess = "saved",
  DraftError = "failed"
}

const CreateOrderExportView: React.FC<CreateOrderViewProps> = ({
  id,
  params
}) => {
  const [isDraftMsg, setIsDraftMsg] = useState(false);
  const intl = useIntl();
  const navigate = useNavigator();
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [isSuccessfully, setSuccessfully] = useState<TypeOfAddProd | null>(
    null
  );
  const [isAddNewItem, setIsAddNewItem] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<CreateOrderPageTab>(
    CreateOrderPageTab.agency
  );
  const [{ fullScreen }, dispatchAppState] = useAppState();
  const [applyAll, setApplyAll] = useState<number>(0);
  const [saveDraft, setSaveDraft] = useState<number>(0);
  const [submitOrderCall, setSubmitOrderCall] = useState<number>(0);
  const [openConfirmOrder, setOpenConfirmOrder] = useState<boolean>(false);
  const [componentKey, setComponentKey] = useState<number>(0);
  const [popupKey, setPopupKey] = useState<number>(0);
  const [listMaterial, setListMaterial] = useState([]);
  const [collectDataAgency, setCollectDataAgency] = useState(null);
  const [collectDataHeader, setCollectDataHeader] = useState(null);
  const [collectDataItem, setCollectDataItem] = useState(null);
  const [orderUpdateInProgress, setOrderUpdateInProgress] = useState(false);
  const [visibleDialogError, setVisibleDialogError] = useState<boolean>(false);
  const [orderProcessStatus, setOrderProcessStatus] = useState<
    OrderProcessStatus
  >(OrderProcessStatus.inconclusive);
  const [keyOrderHeader, setKeyOrderHeader] = useState<number>(0);
  const notify = useNotifier();

  const { updateListSettings, settings } = useListSettings(
    ListViews.EXPORT_ORDER
  );
  const [popUpContent, setPopUpContent] = useState(null);
  const [dialogError, setDialogError] = useState(false);
  const [errorSource, setErrorSource] = useState("");
  const [errorOrders, setErrorOrders] = useState([]);
  const [errorItems, setErrorItems] = useState([]);
  const [orderProcessError, setOrderProcessError] = useState("");
  const [errorCode, setErrorCode] = useState("");

  useEffect(() => {
    updateListSettings("rowNumber", defaultListSettings.EXPORT_ORDER.rowNumber);
  }, []);

  const {
    data,
    loading: loadingExportOrder,
    refetch: refetchExportOrder
  } = useExportOrderWithAllItemsQuery({
    skip: !id,
    variables: {
      orderId: id || undefined
    }
  });
  const taxPercent = useMemo(
    () => data?.exportOrderWithAllItems?.taxPercent || 0,
    [data]
  );

  const formatMaterialGroup = item => {
    if (item.materialGroup2?.includes("K01")) {
      return "K01 - Kraft Roll";
    } else if (item.materialGroup2?.includes("K09")) {
      return "K09 - Gypsum";
    } else {
      return item.materialGroup2;
    }
  };

  const formatConditionGroup = item => {
    if (item.conditionGroup1?.includes("C1")) {
      return "C1 - Container 20'";
    } else if (item.conditionGroup1?.includes("C2")) {
      return "C2 - Container 40'";
    } else if (item.conditionGroup1?.includes("C3")) {
      return "C3 - Container 40' H";
    } else {
      return item.conditionGroup1;
    }
  };

  useEffect(() => {
    if (isAddNewItem) {
      setIsAddNewItem(false);
      return;
    }
    if (data?.exportOrderWithAllItems?.lines && !loadingExportOrder) {
      const _listMaterial: any = [...data.exportOrderWithAllItems.lines].map(
        item => ({
          ...item,
          weightUnit: item.weightUnit === "ตัน" ? "TON" : item.weightUnit,
          weightPerUnit: item.weight,
          baseWeightUnit: item.weightUnit,
          weight: calculateNewTotalWeight(item.quantity, item),
          packageQuantity: calculateNewPackage(
            item.quantity,
            item.rollPerPallet
          ),
          conditionGroup1: formatConditionGroup(item),
          materialGroup2: formatMaterialGroup(item),
          writable: true
        })
      );
      _listMaterial.forEach((item, index) => {
        item.palletNo = calculateNewPalletNo(_listMaterial, index);
        item.packingList = createPackingList(item);
        item.errorQuantity =
          checkTotalQuantity(_listMaterial, item) || !item.quantity;
      });
      setListMaterial(lodash_orderBy(_listMaterial, ["itemNo"], ["asc"]));
      setComponentKey(componentKey + 1);
      setKeyOrderHeader(prev => prev + 1);
    }
  }, [data?.exportOrderWithAllItems?.lines, loadingExportOrder]);

  const {
    currentData,
    next,
    prev,
    toFirst,
    toLast,
    disableNext,
    disablePrev
  } = usePaginationLocal(listMaterial, settings.rowNumber);

  const lastPaginationState = () => {
    toLast();
    setComponentKey(componentKey + 1);
  };

  const handlePreviousFirstPage = () => {
    toFirst();
    setComponentKey(componentKey + 1);
  };

  const handleNextLastPage = () => {
    lastPaginationState();
  };

  const handlePreviousPage = () => {
    prev();
    setComponentKey(componentKey + 1);
  };

  const handleNextPage = () => {
    next();
    setComponentKey(componentKey + 1);
  };

  const handleSort = field => {
    toFirst();
    const sortParam = getSortUrlVariables(field, params);
    const _listMaterial = [...listMaterial];
    switch (sortParam.sort) {
      case "item_no":
        if (sortParam.asc) {
          setListMaterial(lodash_orderBy(_listMaterial, ["itemNo"], ["asc"]));
        } else {
          setListMaterial(lodash_orderBy(_listMaterial, ["itemNo"], ["desc"]));
        }
        break;
      default:
        break;
    }

    setComponentKey(componentKey + 1);
    navigate(
      orderCartlUrl(id, {
        ...getSortUrlVariables(field, params)
      }),
      { replace: true }
    );
  };

  useEffect(() => {
    toFirst();
  }, [settings?.rowNumber]);

  const [handleAddProduct] = useAddProductsToExportOrderMutation({
    onCompleted: data => {
      if (
        data?.addProductsToExportOrder?.errors[0]?.code ===
        ScgpExportErrorCode.PRODUCT_GROUP_ERROR
      ) {
        setPopUpContent(
          <MyTypography variant="body2" className={classes.inlineBlock}>
            กรุณาเลือก{" "}
            <MyTypography variant="subtitle2" className={classes.inlineBlock}>
              สินค้ากลุ่มเดียวกัน
            </MyTypography>{" "}
            ในการสร้างคำสั่งซื้อ
          </MyTypography>
        );
        setVisibleDialogError(true);
        setOrderUpdateInProgress(false);
      } else {
        const allLine = mapEdgesToItems(
          data?.addProductsToExportOrder?.order?.lines
        );
        const listIdOld = listMaterial.map(item => item.id);
        const lineAddNew = allLine.filter(item => !listIdOld.includes(item.id));
        const lineAddNewFormat = lineAddNew.map(item => ({
          ...item,
          weightUnit: item.weightUnit === "ตัน" ? "TON" : item.weightUnit,
          weightPerUnit: item.weight,
          baseWeightUnit: item.weightUnit,
          weight: calculateNewTotalWeight(item.quantity, item),
          packageQuantity: calculateNewPackage(
            item.quantity,
            item.rollPerPallet
          ),
          conditionGroup1: formatConditionGroup(item),
          writable: true
        }));
        setListMaterial(prev => [...prev, ...lineAddNewFormat]);
        setComponentKey(prev => prev + 1);
        setSuccessfully(TypeOfAddProd.Successfully);
        setOrderUpdateInProgress(false);
        setIsAddNewItem(true);
      }
    },
    onError: () => {
      setSuccessfully(TypeOfAddProd.UnSuccessfully);
      setOrderUpdateInProgress(false);
    }
  });

  const { history } = useRouter();
  const classes = useStyles();

  const handleBack = () => {
    history.goBack();
  };

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  const getPriceData = () => {
    let netPrice = 0;
    listMaterial
      .filter(item => item.itemCatEo !== "ZTNN" && item.itemCatEo !== "ZTN1")
      .forEach(
        line =>
          (netPrice +=
            line.quantity * line.piProduct.pricePerUnit * line.weightPerUnit)
      );
    const vat = netPrice * taxPercent;
    const totalPrice = netPrice + vat;
    return {
      itemCount: listMaterial.length || 0,
      netPrice,
      vat,
      totalPrice,
      usd: data?.exportOrderWithAllItems?.pi?.currency || ""
    };
  };

  const priceData = {
    itemCount: getPriceData().itemCount || 0,
    totalPrice: getPriceData().totalPrice || 0,
    vat: getPriceData().vat || 0,
    netPrice: getPriceData().netPrice || 0,
    usd: getPriceData().usd || ""
  };

  const handleApplyAll = () => {
    setApplyAll(applyAll + 1);
  };

  const onApplyAll = value => {
    setApplyAll(0);
    const newListMaterial = listMaterial.map(item => ({
      ...item,
      requestDate: value.requestDate
    }));
    setListMaterial(newListMaterial);
    setComponentKey(prev => prev + 1);
    // UpdateAllExportOrderLine({
    //   variables: {
    //     id,
    //     input: {
    //       requestDate: value.requestDate
    //     }
    //   }
    // }).then(response => {
    //   if (response?.data?.updateAllExportOrderLine?.order?.id) {
    //     const newListMaterial = listMaterial.map(item => ({
    //       ...item,
    //       requestDate: value.requestDate
    //     }));
    //     setListMaterial(newListMaterial);
    //     setComponentKey(prev => prev + 1);
    //   }
    // });
  };

  const [
    _UpdateAllExportOrderLine,
    { loading: loadingApplyAll }
  ] = useUpdateAllExportOrderLineMutation();

  const [
    UpdateExportOrder,
    { loading: loadingUpdateOrder }
  ] = useUpdateExportOrderMutation({
    onCompleted: data => {
      // if (data?.updateExportOrder?.success) {

      //   return;
      // }
      if (data?.updateExportOrder?.order?.id) {
        // refetchExportOrder();
        refetchCart().then(response => reCountCartExport(response));
      }
    },
    onError: error => {
      if (error?.message?.includes("Read timed out")) {
        setOrderProcessStatus(OrderProcessStatus.timeOut);
        return;
      }
    }
  });

  const { refetch: refetchCart } = useTotalCountExportCartQuery({
    skip: true
  });

  const reCountCartExport = response => {
    if (response?.data?.exportCarts?.totalCartItem) {
      const orderCount = response?.data?.exportCarts?.totalCartItem || 0;
      dispatchAppState({
        payload: {
          orderCount
        },
        type: "setOrderCount"
      });
    }
  };

  const [
    SubmitExportOrder,
    { loading: loadingSubmitOrder }
  ] = useUpdateExportOrderMutation({
    onCompleted: data => {
      if (data?.updateExportOrder?.success) {
        refetchCart().then(response => reCountCartExport(response));
        dispatchAppState({
          type: "setViewEditMode",
          payload: {
            viewEditMode: ViewEditMode.VIEW
          }
        });
        showNotifyMessage(
          notify,
          [],
          [],
          [],
          [],
          data?.updateExportOrder?.warningMessages
        );
        if (data?.updateExportOrder?.order?.soNo) {
          dispatchAppState({
            payload: {
              value: false
            },
            type: "setFullScreen"
          });
          navigate(
            `${changeOrderPath(
              data?.updateExportOrder?.order?.soNo
            )}?tab=orderHeader`
          );
        }

        if (data?.updateExportOrder?.iPlanMessages?.length > 0) {
          const iplanErrList = data?.updateExportOrder?.iPlanMessages?.map(
            item => `${item.firstCode}${item.secondCode} - ${item.message}`
          );

          notify({
            status: "error",
            sourceSystem: "IPLAN",
            apiMessage: iplanErrList.join("\n")
          });
        }

        return;
      } else {
        setOrderProcessStatus(OrderProcessStatus.inconclusive);
        dispatchAppState({
          payload: {
            value: false
          },
          type: "setFullScreen"
        });

        if (
          data?.updateExportOrder?.sapOrderMessages?.length > 0 ||
          data?.updateExportOrder?.sapItemMessages?.length > 0
        ) {
          const sapErrorOrders =
            data?.updateExportOrder?.sapOrderMessages?.map(
              ({ errorCode, errorMessage }) => `${errorCode} - ${errorMessage}`
            ) || [];

          const sapErrorItems =
            data?.updateExportOrder?.sapItemMessages?.map(
              ({ itemNo, errorCode, errorMessage }) => ({
                itemNo,
                itemCode: errorCode,
                itemStatus: errorMessage
              })
            ) || [];

          setDialogError(true);
          setErrorSource("SAP");
          setErrorOrders(sapErrorOrders);
          setErrorItems(sapErrorItems);
        } else if (data?.updateExportOrder?.iPlanMessages?.length > 0) {
          const iplanErrorItems = data?.updateExportOrder?.iPlanMessages?.map(
            item => ({
              itemNo: item.itemNo,
              itemCode: `${item.firstCode}${item.secondCode}`,
              itemStatus: item.message
            })
          );

          setDialogError(true);
          setErrorSource("IPLAN");
          setErrorItems(iplanErrorItems);
        } else {
          setOrderProcessStatus(OrderProcessStatus.failed);
          let sapOrderErrors = "";
          let errorCodes = "";
          // eslint-disable-next-line chai-friendly/no-unused-expressions
          data?.updateExportOrder?.errors?.length &&
            data?.updateExportOrder?.errors?.forEach(({ message, code }) => {
              sapOrderErrors += `${message} \n`;
              errorCodes = code;
            });

          // notify({
          //   status: "error",
          //   apiMessage: sapOrderErrors
          // });
          setOrderProcessError(sapOrderErrors);
          setErrorCode(errorCodes);
        }
      }
      handleSaveDraft();
      setIsDraftMsg(false);
      setSuccessfully(null);
    },
    onError: error => {
      setSuccessfully(null);
      if (error?.message?.includes("Read timed out")) {
        setOrderProcessStatus(OrderProcessStatus.timeOut);
        return;
      }
      setOrderProcessStatus(OrderProcessStatus.failed);
      // notify({
      //   status: "error",
      //   apiMessage: error.message
      // });
      setOrderProcessError(error.message);
    }
  });

  let snackBarContent;

  const handleSaveDraft = () => {
    setSaveDraft(saveDraft + 1);
    setIsDraftMsg(true);
    setSuccessfully(TypeOfAddProd.Successfully);
  };

  if (isDraftMsg) {
    snackBarContent = (
      <MyTypography variant="body3" style={{ color: "#ffffff" }}>
        บันทึกฉบับร่างสำเร็จ
      </MyTypography>
    );
  } else {
    snackBarContent = (
      <>
        <MyTypography variant="body3" style={{ color: "#ffffff" }}>
          เพิ่มสินค้าในคำสั่งซื้อสำเร็จ
        </MyTypography>
      </>
    );
  }

  // Auto save draft order every 5 minutes
  const timeToSave = 5; // minutes
  useEffect(() => {
    const intervalId = setInterval(() => {
      handleSaveDraft();
      setIsDraftMsg(false);
      setSuccessfully(null);
    }, 1000 * 60 * timeToSave);
    return () => clearInterval(intervalId);
  }, []);

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleAddProductToExport = values => {
    if (orderUpdateInProgress) {
      return;
    }
    setOrderUpdateInProgress(true);
    const params: ExportOrderLineAddProductInput[] = values.map(item => ({
      piProduct: item.id,
      quantity: item.quantity
    }));
    handleAddProduct({
      variables: { id, input: params }
    });
    setIsDraftMsg(false);
  };

  // Submit Order
  const handleConfirmOrder = () => {
    const listMaterialChange = [...listMaterial].map(item => ({
      id: item.id ?? null,
      quantity: item.quantity ?? null,
      requestDate: item.requestDate ?? null,
      plant: item.plant ?? null,
      rollDiameter: item.rollDiameter ?? null,
      rollCoreDiameter: item.rollCoreDiameter ?? null,
      rollQuantity: item.rollQuantity ?? null,
      palletSize: item.palletSize ?? null,
      rollPerPallet: item.rollPerPallet ?? null,
      palletNo: item.palletNo ?? null,
      packageQuantity: item.packageQuantity ?? null,
      shippingPoint: item.shippingPoint ?? null,
      packingList: item.packingList ?? null,
      deliveryTolUnder: item.deliveryTolUnder ?? null,
      deliveryTolOver: item.deliveryTolOver ?? null,
      route: item.route ?? null,
      deliveryTolUnlimited: item.deliveryTolUnlimited,
      itemCatEo: item.itemCatEo ?? null,
      quantityUnit: item.quantityUnit ?? null,
      refPiNo: item.refPiNo ?? null,
      rejectReason: item?.rejectReason?.toUpperCase() ?? null,
      remark: null,
      shippingMark: item.remark ?? null,
      weightUnit: item.weightUnit === "ตัน" ? "TON" : item.weightUnit ?? null,
      weight: item.weight ?? null
    }));
    const input: ExportOrderUpdateInput = {
      status: ScgpExportOrderStatus.CONFIRMED,
      agency: convertValueObjectToNull(collectDataAgency, null),
      orderHeader: convertValueObjectToNull(collectDataHeader, null),
      lines: listMaterialChange
    };
    setSubmitOrderCall(0);
    handleCloseConfirm();
    setOrderProcessStatus(OrderProcessStatus.success);
    dispatchAppState({
      payload: {
        value: true
      },
      type: "setFullScreen"
    });
    SubmitExportOrder({
      variables: {
        id,
        input
      }
    }).then(() => {
      setCollectDataAgency(null);
      setCollectDataHeader(null);
      setCollectDataItem(null);
    });
  };

  const handleCloseConfirm = () => {
    setOpenConfirmOrder(false);
    // setSubmitOrderCall(0);
    // setVisibleDialogError(false);
    setCollectDataAgency(null);
    setCollectDataHeader(null);
    setCollectDataItem(null);
    setSubmitOrderCall(0);
  };

  const handleOpenConfirm = () => {
    setOpenConfirmOrder(true);
  };

  const submitOrder = () => {
    setSubmitOrderCall(submitOrderCall + 1);
  };

  const isK01K09 = item =>
    item.materialGroup1?.includes("K01") ||
    item.materialGroup1?.includes("K09");

  useEffect(() => {
    if (
      saveDraft &&
      (collectDataAgency || collectDataHeader || collectDataItem) &&
      !dialogError &&
      !visibleDialogError
    ) {
      let listMaterialChange: any[];
      if (collectDataItem) {
        listMaterialChange = [...listMaterial].map(item => ({
          id: item.id,
          quantity: item.quantity,
          requestDate: item.requestDate,
          plant: item.plant,
          rollDiameter: item.rollDiameter,
          rollCoreDiameter: item.rollCoreDiameter,
          rollQuantity: item.rollQuantity,
          palletSize: item.palletSize,
          rollPerPallet: item.rollPerPallet,
          palletNo: item.palletNo,
          packageQuantity: item.packageQuantity,
          shippingPoint: item.shippingPoint,
          packingList: item.packingList,
          deliveryTolUnder: !isK01K09(item) ? item.deliveryTolUnder : undefined,
          deliveryTolOver: !isK01K09(item) ? item.deliveryTolOver : undefined,
          route: item.route,
          deliveryTolUnlimited: !isK01K09(item)
            ? item.deliveryTolUnlimited
            : undefined,
          itemCatEo: item.itemCatEo,
          quantityUnit: item.quantityUnit,
          refPiNo: item.refPiNo,
          rejectReason: item.rejectReason?.toUpperCase(),
          remark: undefined,
          shippingMark: item.remark,
          weightUnit: item.weightUnit === "ตัน" ? "TON" : item.weightUnit,
          weight: item.weight
        }));
      } else {
        listMaterialChange = undefined;
      }
      setSaveDraft(0);
      UpdateExportOrder({
        variables: {
          id,
          input: {
            agency:
              convertValueObjectToNull(collectDataAgency, null) || undefined,
            orderHeader:
              convertValueObjectToNull(collectDataHeader, null, "usage") ||
              undefined,
            lines: listMaterialChange,
            status: ScgpExportOrderStatus.DRAFT
          }
        }
      }).then(() => {
        setCollectDataAgency(null);
        setCollectDataHeader(null);
        setCollectDataItem(null);
      });
    }
  }, [collectDataAgency, collectDataHeader, collectDataItem]);

  useEffect(() => {
    if (submitOrderCall) {
      if (collectDataAgency && collectDataHeader && collectDataItem) {
        handleOpenConfirm();
        setVisibleDialogError(false);
      } else {
        if (collectDataHeader === false) {
          setActiveTab(CreateOrderPageTab.orderHeader);
        }
        if (collectDataItem === false) {
          setActiveTab(CreateOrderPageTab.materialItem);
        }
        setOpenConfirmOrder(false);
        setVisibleDialogError(true);
      }
    }
  }, [collectDataAgency, collectDataHeader, collectDataItem, submitOrderCall]);

  const renderAgencyTab = data?.exportOrderWithAllItems ? (
    <AgencyTab
      dataExportOrder={data?.exportOrderWithAllItems}
      saveDraft={saveDraft}
      submitOrderCall={submitOrderCall}
      setCollectDataSubmit={setCollectDataAgency}
    />
  ) : loadingExportOrder ? (
    <Skeleton />
  ) : (
    ""
  );

  const renderHeaderOrderTab = data?.exportOrderWithAllItems ? (
    <OrderHeaderTab
      key={keyOrderHeader}
      dataExportOrder={data?.exportOrderWithAllItems}
      applyAll={applyAll}
      onApplyAll={handleApplyAll}
      handleApplyAll={onApplyAll}
      saveDraft={saveDraft}
      submitOrderCall={submitOrderCall}
      netPrice={priceData.netPrice}
      setCollectDataSubmit={setCollectDataHeader}
    />
  ) : loadingExportOrder ? (
    <Skeleton />
  ) : (
    ""
  );

  const {
    isSelected: isSelectDelete,
    listElements: listSelectDelete,
    reset: resetDelete,
    toggle: toggleDelete,
    set: setDelete
  } = useBulkActions([]);

  const isErrorQuantity = id =>
    listMaterial.find(item => item.id === id)?.errorQuantity;

  const renderMaterialTab = data?.exportOrderWithAllItems ? (
    <MaterialItemTab
      key={`material_${componentKey}`}
      data={data.exportOrderWithAllItems}
      reFetchExportOrder={refetchExportOrder}
      onPreviousFirstPage={handlePreviousFirstPage}
      onNextLastPage={handleNextLastPage}
      disabled={loadingExportOrder}
      latestPageItemNumber={data?.exportOrderWithAllItems?.lines?.length}
      currency={data?.exportOrderWithAllItems?.pi?.currency}
      onNextPage={handleNextPage}
      onPreviousPage={handlePreviousPage}
      onRowClick={() => null}
      onSort={handleSort}
      totalCount={data?.exportOrderWithAllItems?.lines?.length || 0}
      sort={getSortParams(params)}
      onUpdateListSettings={updateListSettings}
      pageInfo={{
        hasNextPage: !disableNext(),
        hasPreviousPage: !disablePrev()
      }}
      currentTab={activeTab}
      settings={settings}
      submitOrderCall={submitOrderCall}
      setListMaterial={setListMaterial}
      listMaterial={listMaterial}
      listMaterialCurrent={currentData()}
      listMaterialAll={listMaterial}
      saveDraftCall={saveDraft}
      isSelected={isSelectDelete}
      listElements={listSelectDelete}
      set={setDelete}
      reset={resetDelete}
      toggle={toggleDelete}
      isErrorQuantity={isErrorQuantity}
      setCollectDataSubmit={setCollectDataItem}
    />
  ) : null;

  // Loading system
  useEffect(() => {
    const loading =
      loadingUpdateOrder ||
      loadingExportOrder ||
      loadingApplyAll ||
      loadingSubmitOrder;
    dispatchAppState({
      payload: {
        value: loading
      },
      type: "displayLoader"
    });
  }, [
    loadingUpdateOrder,
    loadingApplyAll,
    loadingExportOrder,
    loadingSubmitOrder
  ]);
  //
  // Disable button
  const getDisableAction = useMemo(() => {
    const status = data?.exportOrderWithAllItems?.status;
    const isConfirmed = status === "confirmed";
    const loading =
      loadingUpdateOrder ||
      loadingExportOrder ||
      loadingApplyAll ||
      loadingSubmitOrder;
    return isConfirmed || loading;
  }, [
    loadingUpdateOrder,
    loadingApplyAll,
    loadingExportOrder,
    loadingSubmitOrder,
    data
  ]);

  const handleProcessCreateOrderFailed = () => {
    setOrderProcessStatus(OrderProcessStatus.inconclusive);
    dispatchAppState({
      payload: {
        value: false
      },
      type: "setFullScreen"
    });
  };

  if (params.enabledCreate !== "true") {
    return (
      <OrderProcessingView
        orderProcessStatus={OrderProcessStatus.block}
        onFailed={null}
      />
    );
  }

  return (
    <>
      <div hidden={orderProcessStatus !== OrderProcessStatus.inconclusive}>
        <Container className={classes.boxContainer}>
          {!fullScreen && (
            <>
              <AppHeader onBack={handleBack}>
                <MyTypography variant="body3">
                  {intl.formatMessage({ defaultMessage: "กลับไป" })}
                </MyTypography>
              </AppHeader>
              <PageHeader
                title={intl.formatMessage({ defaultMessage: "Create Order" })}
                subTitle={"(EO)"}
              ></PageHeader>
              <TabContainer>
                <div className={classes.tabBox}>
                  <CategoriesTab
                    testId="categories-tab"
                    isActive={activeTab === CreateOrderPageTab.agency}
                    changeTab={onTabClick}
                  >
                    <MyTypography variant="subtitle1" className={classes.tab}>
                      {intl.formatMessage({
                        defaultMessage: "Agency",
                        description: "subtitle"
                      })}
                    </MyTypography>
                  </CategoriesTab>
                  <CollectionsTab
                    testId="collections-tab"
                    isActive={activeTab === CreateOrderPageTab.orderHeader}
                    changeTab={onTabClick}
                  >
                    <MyTypography variant="subtitle1" className={classes.tab}>
                      {intl.formatMessage({
                        defaultMessage: "Order Header",
                        description: "subtitle"
                      })}
                    </MyTypography>
                  </CollectionsTab>
                  <ProductsTab
                    testId="products-tab"
                    isActive={activeTab === CreateOrderPageTab.materialItem}
                    changeTab={onTabClick}
                  >
                    <MyTypography variant="subtitle1" className={classes.tab}>
                      {intl.formatMessage({
                        defaultMessage: "Material Item",
                        description: "subtitle"
                      })}
                    </MyTypography>
                  </ProductsTab>
                </div>
              </TabContainer>
            </>
          )}

          <div hidden={activeTab !== CreateOrderPageTab.agency}>
            {renderAgencyTab}
          </div>
          <div hidden={activeTab !== CreateOrderPageTab.orderHeader}>
            {renderHeaderOrderTab}
          </div>
          <div hidden={activeTab !== CreateOrderPageTab.materialItem}>
            {renderMaterialTab}
          </div>

          {!fullScreen && (
            <CreateOrderFooter
              onOrder={submitOrder}
              taxPercent={taxPercent}
              priceData={priceData}
              disabled={getDisableAction}
              disabledAddMore={getDisableAction}
              disabledUpdate={!data?.exportOrderWithAllItems?.lines?.length}
              hasValidationError={null}
              activeTab={activeTab}
              onNextTab={onTabClick}
              onPreviousTab={onTabClick}
              onPopup={() => {
                setPopupKey(prev => prev + 1);
                setIsPopupOpen(true);
              }}
              onApplyAll={handleApplyAll}
              onSaveDraft={handleSaveDraft}
            />
          )}

          <DrawAddProduct
            listProductAdded={listMaterial}
            open={isPopupOpen}
            onClose={handleClosePopup}
            contractId={data?.exportOrderWithAllItems?.pi?.id}
            data={{
              piNo: data?.exportOrderWithAllItems?.pi?.code,
              soldTo: data?.exportOrderWithAllItems?.pi?.soldTo?.displayText
            }}
            handleSubmit={handleAddProductToExport}
            title={intl.formatMessage({ defaultMessage: "Add to order" })}
            key={popupKey}
            addType={DrawAddExportType.CREATEORDER}
          />

          <DialogConfirmOrder
            onClose={handleCloseConfirm}
            open={openConfirmOrder}
            onOk={handleConfirmOrder}
          />
          <DialogError
            onClose={() => {
              setVisibleDialogError(false);
              setCollectDataAgency(null);
              setCollectDataHeader(null);
              setCollectDataItem(null);
              setSubmitOrderCall(0);
              setPopUpContent(null);
            }}
            open={visibleDialogError}
            body={popUpContent}
          />

          <DialogConfirmError
            open={dialogError}
            onConfirm={() => setDialogError(false)}
            onCancel={() => setDialogError(false)}
            errorSource={errorSource}
            errorOrders={errorOrders}
            errorItems={errorItems}
          />
        </Container>
        {isSuccessfully && (
          <SnackbarAlert
            severity={isSuccessfully}
            open={!!isSuccessfully}
            onClose={() => setSuccessfully(null)}
            verticalCenter={true}
            anchorOrigin={{ horizontal: "center", vertical: "top" }}
          >
            <div className={classes.snackHeadTitle}>{snackBarContent}</div>
          </SnackbarAlert>
        )}
        <Backdrop open={!!isSuccessfully} className={classes.backDrop} />
      </div>
      {orderProcessStatus !== OrderProcessStatus.inconclusive &&
      orderProcessStatus !== OrderProcessStatus.timeOut ? (
        <OrderProcessingView
          isCreateOrder
          orderProcessStatus={orderProcessStatus}
          onFailed={handleProcessCreateOrderFailed}
          errorCode={orderProcessError}
          code={errorCode}
        />
      ) : (
        ""
      )}
      {orderProcessStatus === OrderProcessStatus.timeOut ? (
        <TimeOutPage
          timeOutText={
            <>
              <MyTypography variant={"body2"}>
                กรุณาตรวจสอบคำสั่งซื้อที่เมนู Inquiry - Order Confirmation
              </MyTypography>
              <MyTypography variant={"body2"}>
                หากไม่พบคำสั่งซึ้อ กรุณาติดต่อ Customer Services: (02-586-5555
                กด 11)
              </MyTypography>
            </>
          }
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CreateOrderExportView;
